import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCogs, FaShieldAlt, FaCarAlt, FaWrench, FaBus, FaBoxes, FaTrash, FaFileAlt, FaTruck, FaBan, FaHackerNewsSquare, FaCalendarAlt, FaExclamationTriangle, FaEnvelopeOpenText, FaTag } from 'react-icons/fa';
import { FaTruckDroplet, FaTruckFast, FaTruckPlane } from "react-icons/fa6";
import { BsPeople, BsPerson } from 'react-icons/bs';
import Sidebar from '../composant_reutilisable/sidebar';
import Navbar from '../composant_reutilisable/navbar';
import useAuth from '../composant_reutilisable/useAuth';
import { useNavigate } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';
import Footer from '../composant_reutilisable/footer';

const Admin = () => {
    useAuth();
    const user_id = localStorage.getItem('userId');
    const navigate = useNavigate();
    const accesGroupe = JSON.parse(localStorage.getItem('accesGroupe')) || [];

    useEffect(() => {
        if (user_id) {
            document.title = "Showtime | Administration";
        }
    }, [user_id]);

    // Définition des éléments de menu avec leurs permissions requises
    const menuItems = [
        { icon: <BsPeople />, text: 'Groupes', link: '/Liste-groupe', accessKey: 'Groupes' },
        { icon: <BsPerson />, text: 'Utilisateurs', link: '/Liste-utilisateur', accessKey: 'Utilisateurs' },
        // { icon: <BsPerson />, text: 'Mots sensibles', link: '/Liste-mots-sensibles', accessKey: 'Motssensibles' },
        // { icon: <FaBan />, text: 'Mots sensibles', link: '/Liste-categorie-mots_sensibles', accessKey: 'Motssensibles' },
        { icon: <FaCalendarAlt />, text: 'Evènements', link: '/Liste-evenement', accessKey: 'Evenement' },
        // { icon: <FaExclamationTriangle />, text: 'Evènements signalés', link: '/Liste-evenements-signales', accessKey: 'Evenement' },
        // { icon: <FaEnvelopeOpenText    />, text: 'Appels', link: '/Liste-demande-reexamen', accessKey: 'Evenement' },
        { icon: <FaTag />, text: 'Categorie Evènement', link: '/Liste-categorie-evenement', accessKey: 'Evenement' },
        // { icon: <ClipboardList />, text: 'Journalisation', link: '/Liste-journalisation', accessKey: 'Journalisation' },
        // { icon: <FaTrash />, text: 'Corbeilles', link: '/Corbeilles', accessKey: 'Corbeille' },
    ];

    const handleClick = (lien) => {
        navigate(lien);
    };

    const userHasAccess = (accessKey) => {
        return accesGroupe.includes(accessKey);
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaCogs size={25} className='mr-2' /> Administration</h2>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to={`/Dashboard`}>Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        Administration
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight text-center p-5">
                        <div className="row mx-auto justify-content-center">
                            {menuItems.map((item, index) => (

                                <div key={index} className="col-md-2 mb-4">
                                    <div
                                        className="card rounded shadow-sm"
                                        onClick={() => handleClick(item.link)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="card-body">
                                            <div className="mb-3 icon-small">{item.icon}</div>
                                            <h5><Link className='text-dark' to={item.link}>{item.text}</Link></h5>
                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>

                    <div className="footer text-center">
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Admin;